import { render, staticRenderFns } from "./PlusLanding.vue?vue&type=template&id=68f945b6&scoped=true"
import script from "./PlusLanding.vue?vue&type=script&lang=js"
export * from "./PlusLanding.vue?vue&type=script&lang=js"
import style0 from "./PlusLanding.vue?vue&type=style&index=0&id=68f945b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f945b6",
  null
  
)

export default component.exports